<app-side-dialog class="min-w-[432px]">
  <div dialogHeader>
    <h2>{{ title() }}</h2>
  </div>

  <div dialogContent>
    <div class="flex flex-col gap-10">
      <app-add-platform-input
        [creatorId]="data.creator?.id ?? null"
        [createChannelIndividually]="!!data.creator?.id"
        [createInstantly]="data.createInstantly ?? true"
        [errorMessage]="addPlatformInputStore.error$()"
        (validatedChannelUrl)="validatedChannelUrl.set($event)"
        (validatedChannelResponse)="validatedChannelResponse.set($event)"
      />

      <div class="flex justify-end gap-3">
        <button
          mat-flat-button
          color="secondary-transparent"
          type="button"
          [disabled]="creatingCreator()"
          (click)="onCloseClick()"
        >
          {{ 'shared.cancel' | translate }}
        </button>

        <button
          mat-flat-button
          type="button"
          data-testid="add-platform-submit"
          [disabled]="!validatedChannelUrl() || creatingCreator()"
          (click)="onSubmit()"
        >
          <p [class.hidden]="creatingCreator()">{{ title() }}</p>

          @if (creatingCreator()) {
            <app-dots-spinner />
          }
        </button>
      </div>
    </div>
  </div>
</app-side-dialog>
